import React from 'react';


const NudeNewsFooter = () => (
  <div className="footer">
    <div className="container">
      <div className="text-center">
        <img
          className="img-wl-footer"
          src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGwAAABHCAIAAABtbzVvAAAAGXRFWHRTb2Z0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"
        />
        <ul className="list-inline">
          <li>
            <a href="/contact">Contact Us</a>
          </li>
          <li>
            <a href="/account/subscriptions">Cancel</a>
          </li>
          <li>
            <a href="http://www.pbplussupport.com/">
              Billing Support
            </a>
          </li>
          <li>
            <a href="/privacy_policy">Privacy Policy</a>
          </li>
          <li>
            <a href="/terms_of_service">Terms of Use</a>
          </li>
        </ul>
        <p
          className="copy montserrat text-center footer-company"
          style={{ float: 'none', textAlign: 'center' }}
        >
          Please visit{' '}
          <a
            href="http://www.achdebit.com/membership.php"
            rel="external"
          >
            WTS
          </a>{' '}
          and{' '}
          <a
            href="https://epoch.com/en/index.html"
            rel="external"
          >
            Epoch
          </a>
          , our authorized sales agents. Please visit{' '}
          <a
            href="http://www.vendosupport.com"
            rel="external"
          >
            Vendo
          </a>
          , our authorized reseller.
          <br />
          <br />{' '}
          <img
            alt="Restricted to adults"
            height={53}
            src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAHgAAAA1CAYAAACKoi9gAAAFLUlEQVR42u2bSWgUQRSGo4n7QUZFEEXjoIIbOTTGQy5KhngQEYwDigejwbnk5JqDIgFFRgS95DJ6iDEqOCoEvQgDXtSDGHHDgOgYERXcxg3cY/uK1MRKWT1d9bpnqrrpB4+E7un/VdXX/Wrp6qqqyMJvdmSmWV0EONx2NAIcbnsNXhMBDretiQCH2y5EgMNtP8CnRIDDbW0R4HDbzQhw+G2hNsASupPALfCeiBPaDhsLmItxKmKFshfg1UEAXF/uGJWqi0NcSyHcQ/CnCr9fFQTAE0MO+IRCuA7wjMLvzwYB8GREiK9BAEzr9kUh3GLwpEo7kBimA96KCPE0IIDbVNIzvWYq+KDCdduMBQw/XQH+ERHiXEAA31dJz8x1fQrXXTcKMJyeBr4BvBf8DzJEs+mA4dIGxVCLmWvTCteRNpzHxW7nbhLyfyIoCx0PbMQrMw2Ae1TTM3NtQrGYB7ibI08gc8CJpUwH/A18manjCS5LfcOkZ3r9BDqAkrUB8NF0SlYQ3CDt9Bg5FzMV8HfwdSYPGJlYO7HpmdHIKWqspE8v8Th5iqlOimgxmkkTAT8BX276lI/GGQX+CJueBWlV1rrpHDpFAY94gqlmhk3dJgB+Bb6LpKwgLLvSOI2KITp8WAGz6Xz7KPsEs39NeoLJGutpko7Bx+vevICIc14xxCIHHdKnvlPU2s/0wWyK7jOpDz7jaXVG76LNDPCfXtMzo5dVLO7VoIyiSZ+7IICA9/qRnhm9lKIeWQGrLfs8mNNoAn+JkCFbRJcGBTBNqc/8SM+M5lxEkfdVvFHg0Gzw5wipN/wqjcGAVxsy43hMRvIVbxQ4XKc4eS9avx99cgUAXzZoWtmgpVHg1A6k5DmTAdMMNWgQ4OO6AFeD30HKthoM+KBhq36fpNYOyvQ2qQkp+xl8loEbCGvogoxptlFno9xASvcaCLjZNtOu6GyUtR4K3mgY4JyhgH+Dz9TVKGRB/iFS/jaZcxqyeWG+jd+0UAnbo3NgssVDwTcbAviIbbb16wQ8lq5WYSfzNToBw6lx4G8V5QY8zgQGEFWo17k4cKiso8TyAt6EkOv2CLgLEbNTJ+A5HhYI7kovyZUH8DWEXItHwC2ImO9JttT5BsbLEl+jDsBweAlSrtYj4Fpk3PU6AXuZMl3UBLgTIeWp//XYD1/SCXiMh8HWL9e5nv9vxsinrx8QUid9AtyFbKfpOre5HPPwFO+uMOBWpFSLT4A3I+Nv1wm4zgPgexUGfEtH/+tDP3y3KrLIIguT2UPbLG36N80c5/fsxplzxQ+nMswx/qPmlECH1y9wZYlRnWKZLAXt4TJyx7NFHYkNbxmuLFlaFhI/5tKOFltmh/YdoUOPWaL2cGgfYTs4MWH7LbKfNs41asKhf7JKTC3+u8b+9w1NzE2fvrXJqGqX+q09tPswL9F3J7hjZJdi8WuBrFO5BA2cdtLmdbhzI+oiUzcZJiLAcZcAMVr5LH9XSwKOO1Qo7rKqhALM1NGSBcyXheoVXADn6Q2aLwE4wT2lfgF2ZFJVIkWxX6/lBYJELKcAWKgvdRfKaeddAMcVAFuCxs5LpOcEfzNxEJNcOX0BXIoJ+wTzd1fCpcGTgj6iFATLTZ9Niz6n6BwiRee5FJ2WSM+isUaxfWN8/egT386UM4sF7MSE7+hJAZIuA5jix04Fm/tMwmFgMHxMoC/6bZYZlMQltEsNsgrCtCUeaFoC7ZzMIIurF2nkPsEgq0/QP1v2v68TctyTX6pufDs4MoksxPYXvFZjXxwxXqIAAAAASUVORK5CYII="
            title={true}
            width={120}
          />{' '}
          <br />
          <br />{' '}
        </p>
        <p style={{ fontSize: '14px' }}>
          Playboy.com, Inc. 9346 Civic Center Dr. #200,
          Beverly Hills, 90210 <br />
          Playboy TV UK Ltd, 20-22 Bedford Row,
          London WC1R 4JS, United Kingdom<br />
        </p>{' '}
        <br />
        <br /> All models, actors and actresses appearing on
        this website are 18 years or older.{' '}
        <a href="/2257">Click here</a> for records required
        pursuant to 18 U.S.C. 2257 Record Keeping Requirements
        Compliance Statement. <br />
        <br /> By entering this site you swear that you are of
        legal age in your area to view adult material and that
        you wish to view such material.
        <p />
      </div>
    </div>
  </div>
);

export default NudeNewsFooter;
